import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import CommonGrid from "../../components/CommonGrid";
import { LiHandleButton } from "../../Utils/CustomComponent";
import classes from "../ReportsNDocuments/reports.module.css";
import { gridColumns_ticket } from "../../Utils/TableColumnDefs";
import urls from "../../Utils/urls";
import axios from "../../axios";
import moment from "moment";

const TicketTable = ({
  refreshTable,
  activeTab = 0,
  setActiveTab,
  setTabsData = null,
}) => {
  const [allTickets, setAllTickets] = useState(null);
  const [status, setStatus] = useState("");

  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const userId = localStorage.getItem("apex_userid");

  const isToday = (createdDate) => {
    const todayFormatted = moment().format("MM/DD/YY");
    const ticketCreatedDate = moment(createdDate, "MM/DD/YY hh:mm A").format(
      "MM/DD/YY"
    );
    return todayFormatted === ticketCreatedDate;
  };

  useEffect(() => {
    setStatus("loading");
    // axios
    //   .get(urls.support.getAllTickets(userId), {
    //     headers: {
    //       Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
    //     },
    //   })
    axios
      .get(urls.support.getStatusTickets(userId, tabButtons?.[activeTab].key), {
        headers: {
          Authorization: "Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==",
        },
      })
      .then((res) => {
        setAllTickets(res.data.items);
        setStatus("fulfilled");

        if (setTabsData !== null) {
          const newTabsData = [
            {
              length: res.data.items?.filter((ticket) =>
                isToday(ticket.created)
              )?.length,
              ticketStatus: "Tickets Created Today",
              color: "#333",
            },
            {
              length: res.data.items?.filter(
                (ticket) => ticket.assignee === null
              )?.length,
              ticketStatus: "Unassigned Tickets",
              color: "#60a5fa",
            },
            {
              length: res.data.items?.filter((ticket) =>
                ticket.status_type.includes("Open")
              )?.length,
              ticketStatus: "Open Tickets",
              color: "#60a5fa",
            },
          ];
          setTabsData(newTabsData);
        }
      });
  }, [refreshTable, userId, activeTab]);

  return (
    <div className="pt-5 bg-white col-sm-12">
      <ul className="nav nav-tabs">
        {tabButtons.map((data, index) => (
          <LiHandleButton
            key={index}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            label={data.label}
            value={index}
            handleBtnClick={setActiveTab}
          />
        ))}
      </ul>

      {
        <div
          className="p-5"
          style={!isLargeDevice ? { overflowY: "scroll" } : null}
        >
          <CommonGrid
            className={`loans_in_workout bg-white col-sm-12 tickets-table ${
              !isLargeDevice ? classes.pastDue15 : ""
            }`}
            // title={"Tickets"}
            title={tabButtons?.[activeTab].title}
            gridColumns={gridColumns_ticket}
            columnData={allTickets?.length ? allTickets : []}
            status={status}
          />
        </div>
      }
    </div>
  );
};

export default TicketTable;

const tabButtons = [
  { label: <p>Open</p>, title: "Open Tickets", key: "OPEN" },
  { label: <p>Closed</p>, title: "Closed Tickets", key: "CLOSED" },
];
